import React from "react";
import { useSelector } from "react-redux";

const QuestionList = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const OPTIONS = answeringQuestions.listData.map( ( v, i ) => <option key={ i }>{ v.qstCd }</option> );

  return (
    <div className="inspection-select-wrap">
      <select value={ answeringQuestions.data.qstCd } onChange={ props.onChange }>{ OPTIONS }</select>
    </div>
  );

};

export default QuestionList;
